// extracted by mini-css-extract-plugin
export default {"logo":"Logo_logo__-3Af1","logo--small":"Logo_logo--small__lcl3Q","logo--normal":"Logo_logo--normal__cv3A3","logo--large":"Logo_logo--large__+wDAS"};